// extracted by mini-css-extract-plugin
export default {"title":"RecognitionTab_title__v+GYm","card":"RecognitionTab_card__p9BGn","select":"RecognitionTab_select__-vnhE"};